import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import { MenuItem, Select } from '@mui/material';
import { useMobile } from 'utils/media';
import Icon from '../../../components/Icon';
//import Loading from 'components/Loading';

import './index.sass';

const { cnBlock, el } = bem('form-field', 'form-select');

export default ({ className, name, options, value, onBlur = () => {}, loading = false, placeholder = 'Выберите', mod = '', error, ...props }) => {

    const [ open, setOpen ] = useState(false);
    const { isMobile } = useMobile();

    const [ showPlaceholder, setShowPlaceholder] = useState(true);

    useEffect(() => {
        if (value !== '') {
            setShowPlaceholder(false);
        }
    }, [value])

    const menuProps = {
        classes: {
            list: el('list')
        },
        autoFocus: false,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        PopoverClasses: {
            paper: el('dropdown')
        }
    };

    const selectDisplayProps = {
        className: el('select-input', {'override-padding-right': mod === '', 'placeholder': showPlaceholder})
    };

    const InputUnclassed = React.forwardRef(function (props, ref) {
        const { className, classes, inputComponent: InputComponent, inputProps,...rest} = props;
        return (
            <div className={el('select')}>
                <InputComponent ref={ref} {...inputProps} {...rest} />
            </div>
        )
    })

    const optionsByValue = Object.fromEntries(options.map((option, index) => [option.value, option.label]));

    const rValue = (value) => {
        return value?.length ?
            Array.isArray(value) ?
                value.map(x => optionsByValue[x]).join(', ') :
                optionsByValue[value] :
            placeholder;
    }

    const Option = isMobile ? 'option' : MenuItem;
    const rOption = ( value, label, props, index ) => {
        return isMobile ?
            <option key={index} value={value}>{label}</option> :
            <Option disableRipple={true} key={index} value={value} {...props}>{label}</Option>
    };

    return (
        <div className={cnBlock(className, mod, {'disabled': props.disabled})}>
            <Select
                autoWidth={true}
                name={name}
                input={<InputUnclassed />}
                disabled={loading || props.disabled}
                MenuProps={menuProps}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={(e) => {
                    onBlur(e);
                    setOpen(false);
                }}
                SelectDisplayProps={selectDisplayProps}
                displayEmpty={true}
                value={value}
                renderValue={rValue}
                native={isMobile}
                inputProps={isMobile ? selectDisplayProps : {}}
                IconComponent={() => loading ? 'loading' : <Icon className={el('select-icon', { 'open': open })} name='caret-down' />}
                {...props}
            >
                { options.map(({value, label, props}, index) =>
                    rOption(value, label, props, index)
                )}
            </Select>
            {error && <div className='form-error'>{error}</div>}
        </div>
    )
}
